import './Hero.scss'
import Heading from '../Heading/Heading'
import Text from '../Text/Text'

const Hero = ({ title, text, imageProps }) => {
  let splitImage = imageProps.mobileImage.src.split('.')
  return (
    <div className="hero-container">
      <div className="hero-info">
        <Heading type="h1" headingSize="display" className="hero-heading">
          {title}
        </Heading>
        <Text>{text}</Text>
      </div>
      <picture className="hero-image-container">
        <source
          srcSet={imageProps.mobileImage.src}
          media="(max-width: 640px)"
          type={`image/${splitImage[splitImage.length - 1]}`}
          data-testid="hero-img-source-id"
        />
        <img
          className="hero-image"
          src={imageProps.desktopImage.src}
          alt={imageProps.mobileImage.alt}
          sizes="(max-width: 640px) 640px,
            785px"
          width="785"
          height="524"
        />
      </picture>
    </div>
  )
}

export default Hero
